import type { IndustryType } from "@/components/filters/Industries/types";

export type IndustrySlice = {
  industryIds: number[];
  sicIds: string[];
  naicsIds: string[];
  excludedIds: number[];
  excludedSicIds: string[];
  excludedNaicsIds: string[];
  selectedIndustryType?: IndustryType;
};

export const defaultIndustrySlice: IndustrySlice = {
  industryIds: [],
  sicIds: [],
  naicsIds: [],
  excludedIds: [],
  excludedSicIds: [],
  excludedNaicsIds: [],
  selectedIndustryType: "INDUSTRY",
};

export function isAllIndustriesEmpty(payload: IndustrySlice): boolean {
  return (
    payload.industryIds.length === 0 &&
    payload.sicIds.length === 0 &&
    payload.naicsIds.length === 0 &&
    payload.excludedIds.length === 0 &&
    payload.excludedSicIds.length === 0 &&
    payload.excludedNaicsIds.length === 0
  );
}

export function inferIndustryType(payload: IndustrySlice): IndustryType {
  if (payload.industryIds.length > 0 || payload.excludedIds.length > 0) {
    return "INDUSTRY";
  }
  if (payload.sicIds.length > 0 || payload.excludedSicIds.length > 0) {
    return "SIC";
  }
  if (payload.naicsIds.length > 0 || payload.excludedNaicsIds.length > 0) {
    return "NAICS";
  }
  return "INDUSTRY";
}
